export default function Logo() {
  return (
    <img
      src="/logo.png"
      alt="PranIQ"
      draggable={false}
      className="h-9 w-auto select-none"
    />
  );
}
